var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectCheckListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.71,
    cy: 33.71,
    r: 30.71,
    fill: "#2E406F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4923 48.8334L26.3606 47.6878C26.0372 47.3605 25.6522 47.1889 25.2055 47.1732C24.7588 47.1575 24.3712 47.3107 24.0428 47.633C23.7155 47.9563 23.5504 48.3419 23.5477 48.7898C23.545 49.2377 23.7053 49.6248 24.0286 49.951L26.3325 52.2832C26.6559 52.6105 27.0344 52.7755 27.4682 52.7781C27.902 52.7808 28.2826 52.6204 28.6099 52.2971L34.4608 46.5172C34.7881 46.1938 34.9466 45.8152 34.9362 45.3814C34.9259 44.9475 34.7585 44.5669 34.434 44.2396C34.1105 43.9394 33.7319 43.7814 33.2982 43.7658C32.8645 43.7501 32.484 43.9034 32.1567 44.2257L27.4923 48.8334ZM10.6563 47.8786L19.283 47.8886C19.7439 47.8914 20.1315 47.7376 20.4457 47.4272C20.7599 47.1168 20.9179 46.7316 20.9196 46.2718C20.9224 45.8109 20.7686 45.4234 20.4582 45.1091C20.1478 44.7949 19.7627 44.6369 19.3029 44.6352L10.6762 44.6253C10.2153 44.6225 9.82775 44.7763 9.51352 45.0867C9.19928 45.3971 9.04131 45.7822 9.03958 46.242C9.03677 46.7029 9.19057 47.0905 9.50099 47.4047C9.8114 47.7189 10.1965 47.8769 10.6563 47.8786ZM10.6861 41.9986L25.8196 42.0483C26.2804 42.0511 26.668 41.8973 26.9822 41.5869C27.2965 41.2764 27.4544 40.8913 27.4562 40.4315C27.459 39.9706 27.3052 39.5831 26.9948 39.2688C26.6844 38.9546 26.2992 38.7966 25.8394 38.7949L10.706 38.7452C10.2451 38.7424 9.85755 38.8962 9.54332 39.2066C9.22909 39.517 9.07111 39.9022 9.06939 40.362C9.06657 40.8229 9.22037 41.2104 9.53079 41.5247C9.8412 41.8389 10.2263 41.9969 10.6861 41.9986ZM10.7159 36.1186L25.8494 36.1682C26.3102 36.171 26.6978 36.0172 27.012 35.7068C27.3263 35.3964 27.4842 35.0113 27.486 34.5515C27.4888 34.0906 27.335 33.703 27.0246 33.3888C26.7142 33.0746 26.329 32.9166 25.8692 32.9149L10.7358 32.8652C10.2749 32.8624 9.88735 33.0162 9.57312 33.3266C9.25889 33.637 9.10091 34.0221 9.09919 34.4819C9.09637 34.9428 9.25017 35.3304 9.56059 35.6446C9.871 35.9589 10.2561 36.1168 10.7159 36.1186Z",
    fill: "#021239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2L59 58",
    stroke: "#0F1E45",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5L58 61",
    stroke: "#2E406F",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCheckListIcon);
export default __webpack_public_path__ + "static/media/SelectCheckListIcon.0d9e97c3c985e093de15bde73087d3ec.svg";
export { ForwardRef as ReactComponent };